import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';

import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import {Users} from "../../main/pages/_sommavi/models/Users";
import {LastActiveService} from "../../main/pages/_sommavi/services/activity/last-active.service";

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  //public
  public currentUser: Observable<Users>;

  //private
  private currentUserSubject: BehaviorSubject<Users>;
  // private apiUrl = 'http://192.168.43.136:3000'environment.apiUrl;


  /**
   * CONSTRUCTOR
   * @param _http
   * @param _toastrService
   * @param _lastActiveService
   */
  constructor(
      private _http: HttpClient,
      private _lastActiveService: LastActiveService,
      private _toastrService: ToastrService) {
    this.currentUserSubject = new BehaviorSubject<Users>(JSON.parse(sessionStorage.getItem('currentUser')));
    // this.currentStructureSubject = new BehaviorSubject<Structure>(JSON.parse(sessionStorage.getItem('structure')));
    // this.currentAnneeEnCours = new BehaviorSubject<Annee>(JSON.parse(sessionStorage.getItem('anneeEnCours')));
    this.currentUser = this.currentUserSubject.asObservable();


  }

  // getter: currentUserValue
  public get currentUserValue(): Users {
    return this.currentUserSubject.value;
  }


  //-> VRAI SI LE COMPTE CONNECTE POSSEDE AU MOINS UNE DES PERMISSIONS (champ "access")
  hasAnyPermission(permissions: string[]): boolean {
    const user: any = this.currentUserSubject.value;
    if (!user || !Array.isArray(user.permissions)) return false;
    return user.permissions.some(p => permissions.indexOf(p.access) > -1);
  }

  //-> A APPELER APRES UNE CONNEXION REUSSIE : SESSION + UTILISATEUR COURANT (LE MENU ET L'INTERCEPTEUR EN DEPENDENT)
  connecter(user: Users, token: string): void {
    sessionStorage.setItem('currentUser', JSON.stringify(user));
    sessionStorage.setItem('token', token);
    this.currentUserSubject.next(user);
  }

  //-> MET A JOUR L'UTILISATEUR COURANT (ex. nouveaux magasins d'action) SANS NOUVELLE CONNEXION
  mettreAJourUtilisateur(modifs: Partial<Users>): void {
    const user = { ...(this.currentUserSubject.value as any), ...modifs };
    sessionStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUserSubject.next(user);
  }

  isAuthorized(roles) {
    let curentUserRoles = this.currentUserSubject.value.roles;
    if (roles.indexOf(curentUserRoles.nom.toString()) > -1) return true;
    return false;
  }

  /**
   * User login
   *
   * @param username
   * @param password
   * @returns user
   */
  login(usernameOrPhone: string, password: string) {
    return this._http.post<any>(`${environment.apiUrl}auth/login`, { usernameOrPhone, password });
      // .pipe(
      //   map(res => {
      //
      //
      //     return res.user;
      //   })
      // );
  }

  /**
   * User logout
   *
   */
  logout() {
    // notify
    sessionStorage.clear();
    this.currentUserSubject.next(null);

    localStorage.removeItem(this._lastActiveService.localStorageKey);
    this._lastActiveService.loggedIn.next(false);


  }
}
